module.exports = __webpack_public_path__ + "static/media/image9_deu.86fd0fb1.png";